import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { gamAdUnitByName } from "@bufox/gatsby-utils/fe/google-services/ad-manager/utils"
import AdSlotWithDevSupport from "@bufox/gatsby-utils/fe/google-services/ad-manager/ad-slot-with-dev-support"

const DesktopSkin = ({ className, adUnitName }) => {
  const adUnitConfiguration = gamAdUnitByName(adUnitName)
  return (
    adUnitConfiguration && (
      <div className={className}>
        <AdSlotWithDevSupport
          // https://react-dfp.surge.sh/examples/basic/
          adSlotId={`ad-slot-desktop-skin`}
          adUnitConfiguration={adUnitConfiguration}
        ></AdSlotWithDevSupport>
      </div>
    )
  )
}

DesktopSkin.propTypes = {
  adUnitName: PropTypes.string,
  className: PropTypes.string,
}

const StyledDesktopSkin = styled(DesktopSkin)`
  background-color: #f4f4f4;
  width: 100%;
  height: 100%;
  img {
    display: block;
    margin: 0 auto;
  }
`

export default StyledDesktopSkin
